<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px" :rules="rules">
					<el-row>
						<el-col :span="24">
							<el-form-item label="名称" prop="name"><el-input v-model="formParameter.name" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="图片链接" prop="url">
                <!-- <el-input v-model="formParameter.url" autocomplete="off"></el-input> -->
                   <image-upload v-model="formParameter.url"   @change="callBacklogoUrl" model="fileSystem" uri="/statics/online" :size="80000"></image-upload>
                </el-form-item>
						</el-col>
					</el-row>
          
					<el-row>
						<el-col :span="24">
							<el-form-item label="路由地址" prop="jumpto">
                <el-input v-model="formParameter.jumpto" autocomplete="off"></el-input>
 
									</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="24">

						
							<el-form-item label="可用状态" prop="state">
								<!-- <el-input v-model="formParameter.state" autocomplete="off"></el-input> -->
							<el-switch
                            v-model="formParameter.state">
                              </el-switch>
									</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="排序" prop="sort"><el-input v-model="formParameter.sort" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import imageUpload from '@/components/biz/imageUpload/imageUpload.vue';
import api from "@/api/online/onlinecarousel/onlinecarousel.js";
import constant from '@/util/constant.js';
export default {
  name: "edit",
  components: {
    popup,
    imageUpload
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      baseUrl:constant.serverUrl+"/",
      rules: {
        //
        name: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 255,
            trigger: "blur",
          },
        ],
        //图片链接
        url: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 255,
            trigger: "blur",
          },
        ],
        //排序
        sort: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 4,
            trigger: "blur",
          },
        ],
        //
        createTime: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //
        updateTime: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    callBacklogoUrl(fname) {
      if(fname){
        this.formParameter.url = this.baseUrl+ fname.substring(fname.lastIndexOf("/statics/online"));
       }
    },
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.disabled = disabled;
      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
         let parameter = this.$utils.merger(this.formParameter);
		     //处理下可用状态判断
		     parameter.state =  parameter.state?1:2;
         //处理图片路径问题
        if (!this.parameter.id) {
          //添加
          api.save(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    },

    init() {
      
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;
          this.formParameter.url= this.baseUrl+this.formParameter.url;
          
		  if(this.formParameter.state==1){
          this.formParameter.state = true;
		  }else{
			  this.formParameter.state = false;
		  }
		   
          this.popupLoading = false;
        });
      } else {
        //添加
        this.popupLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
